/**
 * @generated SignedSource<<a2e2f408eac015eb03e322fa988e8a33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CancelMemberPackageInput = {
  id: string;
  revokeAccess?: boolean | null | undefined;
};
export type useCancelMemberPackageMutation$variables = {
  input: CancelMemberPackageInput;
};
export type useCancelMemberPackageMutation$data = {
  readonly cancelMemberPackage: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
    } | null | undefined>;
    readonly memberPackage: {
      readonly cancelledOn: string | null | undefined;
      readonly endsOn: string | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCancelMemberPackageMutation = {
  response: useCancelMemberPackageMutation$data;
  variables: useCancelMemberPackageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelledOn",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endsOn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCancelMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelMemberPackagePayload",
        "kind": "LinkedField",
        "name": "cancelMemberPackage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberPackage",
            "kind": "LinkedField",
            "name": "memberPackage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCancelMemberPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelMemberPackagePayload",
        "kind": "LinkedField",
        "name": "cancelMemberPackage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberPackage",
            "kind": "LinkedField",
            "name": "memberPackage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9351e58c45e7618cd2ae277810ac2f81",
    "id": null,
    "metadata": {},
    "name": "useCancelMemberPackageMutation",
    "operationKind": "mutation",
    "text": "mutation useCancelMemberPackageMutation(\n  $input: CancelMemberPackageInput!\n) {\n  cancelMemberPackage(input: $input) {\n    memberPackage {\n      cancelledOn\n      endsOn\n      id\n    }\n    success\n    errors {\n      __typename\n      field\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6d94a02b0a523acf0dc714f623ecefd";

export default node;
